import type { Order } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'orders';
const dataPath = `${rootPath}/data`;

export function getOrdersData(query?: Order.SearchQuery) {
    return api.get<Order.SalesReportSearchResponse>(`${rootPath}`, query);
}

export function getOrderById(id: number) {
    return api.get<Order.DetailsResponse>(`${rootPath}/${id}`);
}

export function getOrderImageUrls(id: number) {
    return api.get<Order.ImageUrlsResponse>(`${rootPath}/${id}/image-urls`);
}

export function getOrdersSummary(query?: Order.SummaryQuery) {
    return api.get<Order.SummaryModel[]>(`${dataPath}/summary`, query);
}

// export function getBusinessOrders(query: BusinessOrderDetails.SearchQuery) {
//     return api.get<BusinessOrderDetails.SearchResponse>(
//         `${rootPath}/business`,
//         query
//     );
// }
